import { Component } from '@angular/core';
import { environment } from '@env';

@Component({
  selector: 'app-root',
  template: `<app-navigation>
    <ant-notification-banner></ant-notification-banner>
    <router-outlet></router-outlet>
  </app-navigation>`,
  styles: [
    `
      ant-notification-banner:not(:empty) {
        margin-bottom: 1rem;
      }
    `,
  ],
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class AppComponent {}
